'use client';

type ChevronUpProps = {
    fill?: string;
    width?: string;
    height?: string;
    className?: string;
};

export const ChevronUp = ({ fill = '#ffffff', width = '24', height = '24', className = '' }: ChevronUpProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}>
            <path d="M18 15L12 9L6 15" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
